module.exports = __webpack_public_path__ + "img/scroll-down.f8c2c76f.svg";